import React, { useState } from "react";
import { View, Image, ScrollView, Pressable } from "react-native";
import { useTheme } from "@emotion/react";
import { ODSText } from "../../atoms/ODSText";
import { ODSInput } from "../../atoms/ODSInput";
import ODSButton from "../../atoms/ODSButton";
import { ODSTextArea } from "../../atoms/ODSTextArea";
import { ODSIcon } from "../../atoms/ODSIcon";

const ReportsForm = ({
  title,
  setTitle,
  descriptionText,
  setDescriptionText,
  issueImages,
  setIssueImages,
  onSubmit,
  renderFilePicker,
  renderCatogroriesDropDown,
  renderRoomDropDown,
  type,
  renderDatePicker,
  isRow
}) => {
  const { colors } = useTheme();
  const [titleError, setTitleError] = useState("");

  /** 🔍 Validate title before submit */
  const handleSubmit = () => {
    let isValid = true;

    if (!title || !title.trim()) {
      setTitleError("Report title is required");
      isValid = false;
    } else if (title.trim().length < 3) {
      setTitleError("Title must be at least 3 characters long");
      isValid = false;
    } else {
      setTitleError("");
    }

    if (isValid) {
      onSubmit();
    }
  };

  const removeFile = (index) => {
    setIssueImages((prev) => prev.filter((_, i) => i !== index));
  };
  console.log("issueImages", issueImages)
  return (
    <View
      style={{
        backgroundColor: "white",
        borderRadius: 20,
        padding: 20,
        width: "100%",
        shadowColor: "#000",
        shadowOpacity: 0.05,
        shadowOffset: { width: 0, height: 2 },
        shadowRadius: 6,
      }}
    >
      <ODSText
        textAlign="left"
        type="h5"
        color={colors.text.primary}
        marginBottom={20}
      >
        {type == "edit" ? "Edit reported issue" : "Report an Issue"}
      </ODSText>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",

        }}
      >
        <View style={{ flex: 1, marginRight: 10 }}>
          <ODSInput
            width="100%"
            value={title}
            label="Report Title"
            onChange={(text) => {
              setTitle(text);
              setTitleError("");
            }}
            showError={!!titleError}
            hints={
              titleError
                ? [{ hint: titleError, state: "error" }]
                : [{ hint: "", state: "default" }]
            }
          />
        </View>

        <View style={{ flex: 1, marginLeft: 10 }}>
          {renderDatePicker()}
        </View>
      </View>
      {isRow ?
        <View
          style={{
            flexDirection: 'column',
          }}
        >
          <View style={{ flex: 1, width: "100%" }}>
            {renderRoomDropDown()}
          </View>

          <View style={{ flex: 1, width: "100%" }}>
            {renderCatogroriesDropDown()}
          </View>
        </View> :

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 16,
          }}
        >
          <View style={{ flex: 1, marginRight: 10 }}>
            {renderRoomDropDown()}
          </View>

          <View style={{ flex: 1, marginLeft: 10 }}>
            {renderCatogroriesDropDown()}
          </View>
        </View>}
      {/* Description */}
      <View style={{ marginBottom: 20 }}>
        <ODSTextArea
          label="Describe your issue here"
          value={descriptionText}
          onChange={setDescriptionText}
          maxLength={400}
          placeholder="Enter issue details..."
          hints={[
            {
              hint: `${descriptionText.length}/400 character limit`,
              state: "default",
            },
          ]}
        />
      </View>
      <View style={{ marginBottom: 20 }}>
        {renderFilePicker()}

        {issueImages?.length > 0 && (
          <ScrollView horizontal style={{ marginTop: 10 }}>
            {issueImages.map((img, index) => (
              <View key={index} style={{ marginRight: 10 }}>
                <Image
                  source={{ uri: img }}
                  style={{
                    width: 150,
                    height: 150,
                    borderRadius: 10,
                    borderWidth: 1,
                    borderColor: colors.border?.default || "#ddd",
                  }}
                />
                <Pressable
                  style={{
                    alignSelf: "center",
                    flexDirection: "row",
                    marginTop: 6,
                  }}
                  onPress={() => removeFile(index)}
                >
                  <ODSIcon
                    size={32}
                    icon="TB-Trash"
                    color={colors.main.red["700"]}
                  />
                </Pressable>
              </View>
            ))}
          </ScrollView>
        )}
      </View>

      {/* Submit button */}
      <View style={{ alignItems: "flex-end", marginTop: 20 }}>
        <ODSButton restStyle={{ width: 180 }} type="primary" onPress={handleSubmit}>
          {type == "edit" ? "Update Report" : "Submit Report"}
        </ODSButton>
      </View>
    </View>
  );
};

export default ReportsForm;
